// React imports
import React from 'react';

// gatsby imports
import { PageProps, graphql } from 'gatsby';

// SEO
import SEO from 'components/seo';

// Theme and layout
import WithTheme from 'components/WithTheme';
import Layout from 'views/Layout';

// Page views
import NoticePrivacy from 'views/NoticePrivacy';

type DataProps = {
    site: {
        buildTime: string;
    };
};

const AvisoPrivacidadPage: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <WithTheme>
        <Layout location={location}>
            <SEO title="Aviso de Privacidad" />

            <NoticePrivacy />
        </Layout>
    </WithTheme>
);

export default AvisoPrivacidadPage;

export const query = graphql`
    {
        site {
            buildTime(formatString: "YYYY-MM-DD hh:mm a z")
        }
    }
`;
